import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import axios from "axios";
import DataTable from "react-data-table-component";

const Exhibitions = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [newdataLive, setNewdataLive] = useState({
    id: "0",
    exhibitionTitle: "",
    dateStart: new Date(),
    dateEnd: new Date(),
    imageURL: "",
    exhibitionDate: "",
    description: "",
  });
  const [newdataNext, setNewdataNext] = useState({
    id: "0",
    exhibitionTitle: "",
    dateStart: new Date(),
    dateEnd: new Date(),
    imageURL: "",
    exhibitionDate: "",
    description: "",
  });
  const [newdataUpcoming, setNewdataUpcoming] = useState([]);

  const fetchExhibitionDetails = useCallback(async () => {
    try {
      const [responseLive, responseNext, responseUpcoming] = await Promise.all([
        axios.get(`https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionDetailsLive`),
        axios.get(`https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionDetailsNext`),
        axios.get(`https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionDetailsUpcoming`),
      ]);

      // Update Live Exhibition Data
      if (responseLive.data) {
        const dataLive = responseLive.data;
        setNewdataLive({
          ...newdataLive,
          id: dataLive.id,
          exhibitionTitle: dataLive.exhibitionTitle,
          exhibitionDate: dataLive.exhibitionDate,
          imageURL: dataLive.imageURL,
          description: dataLive.description,
        });
      }

      // Update Next Exhibition Data
      if (responseNext.data) {
        const dataNext = responseNext.data;
        setNewdataNext({
          ...newdataNext,
          id:dataNext.id,
          exhibitionTitle: dataNext.exhibitionTitle,
          exhibitionDate: dataNext.exhibitionDate,
          imageURL: dataNext.imageURL,
          description: dataNext.description,
        });
      }

      // Update Upcoming Exhibitions Data
      if (responseUpcoming.data) {
        setNewdataUpcoming(responseUpcoming.data);
      }
    } catch (error) {
      console.error("Error fetching exhibition details:", error);
    }
  }, []);

  

  // Preprocess data to group artworks by artist
  const groupArtworksByArtist = (artworks, shuffleOnly = false) => {
    // Shuffle function
    const shuffleArray = (array) => {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    };

    // If shuffleOnly is true, just shuffle the input and return
    if (shuffleOnly) {
      return shuffleArray(artworks);
    }

    // Group artworks by artist
    const groupedData = artworks.reduce((acc, item) => {
      const { artistID, artistName, imageURLArtist, imageURLArtwork, productTitle } = item;

      if (!acc[artistID]) {
        acc[artistID] = {
          artistID,
          artistName,
          imageURLArtist,
          artworks: [],
        };
      }
      acc[artistID].artworks.push({
        imageURLArtwork,
        productTitle,
      });

      return acc;
    }, {});

    // Convert object back to an array and shuffle the grouped data
    const groupedArray = Object.values(groupedData);
    return shuffleArray(groupedArray);
  };


  const [newExbArtistLive, setNewExbArtistLive] = useState([]);

  const getExbArtistLive = async () => {
    try {
      const response = await axios.get('https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionLiveArtworkDetailsByExhibitionID?exhibitionID=' + newdataLive.id)
      
      if (response.data) {
        setLoading(true);
        const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
        await delay;

        // Set grouped and shuffled data
        const groupedAndShuffledArtists = groupArtworksByArtist(response.data);
        setNewExbArtistLive(groupedAndShuffledArtists);
      }
    }
    catch (error) {
      console.log(error)
    }
  };


  const [newExbArtistNext, setNewExbArtistNext] = useState([]);
  const getExbArtistNext = async () => {
    try {
      const response = await axios.get('https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionLiveArtworkDetailsByExhibitionID?exhibitionID=' + newdataNext.id)
      
      if (response.data) {
        setLoading(true);
        const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
        await delay;

        // Set grouped and shuffled data
        const groupedAndShuffledArtists = groupArtworksByArtist(response.data);
        setNewExbArtistNext(groupedAndShuffledArtists);
      }
    }
    catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {
    fetchExhibitionDetails();
  }, [fetchExhibitionDetails]);
  
  useEffect(() => {
    if (newdataLive.id !== "0" || newdataNext.id !== "0") {
      getExbArtistLive();
      getExbArtistNext();
    }
  }, [newdataLive.id, newdataNext.id]);  // Runs only when the exhibition ID changes

  const columns = [
    {
      cell: (row) => (
        <img
          src={row.imageURL !== "NA" ? "../images/exhibition/thumbnail/"+row.imageURL : "../images/exhibitionImage.jpeg"}
          alt="Exhibition"
          height={150}
          style={{ objectFit: "cover" }}
        />
      ),
      width: "400px",
    },
    {
      cell: (row) => (
        <div>
          <h2 className="fs-6">{row.exhibitionTitle}</h2>
          <span className="d-block">
            <b>Exhibition Date:</b> {row.exhibitionDate}
          </span>
          <span
            className="d-block"
            dangerouslySetInnerHTML={{
              __html: `<b>About Exhibition:</b> ${row.description}`,
            }}
          />
        </div>
      ),

    },
  ];

  const handleExbDetails = (exhibitionID, artistID) => {
    navigate(`/exhibitionDetails/${exhibitionID}-${artistID}`);
    window.scrollTo({
      top: 0,
      behavior: "instant"
    });
  };

  const handleArtistLiveClick = (artistId, artistName) => {
    const artist = artistName.replace(/ /g, '-'); // Replace spaces with '-'
       navigate(`/artist/${artist}-${artistId}`, { state: { artistId: artistId}});
       window.scrollTo({
           top: 0,
           behavior: "instant"
       });
 };

  const handleArtistNextClick = (artistId, artistName) => {
     const artist = artistName.replace(/ /g, '-'); // Replace spaces with '-'
        navigate(`/artist/${artist}-${artistId}`, { state: { artistId: artistId}});
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
  };

  return (
    <>
      <Header />
      <div className="exhibition" style={{ marginTop: "125px" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-5">
              <h2 className="sec_title">
                Online Art Exhibitions by Upcoming and Established Contemporary
                Indian Artists
              </h2>

              <div className="details">
                <p>
                  <b>IndiGalleria brings the art world to you!</b> For over
                  three years, we've been a leading platform showcasing the best
                  in contemporary Indian art through our innovative online
                  exhibitions.
                </p>
                <p>
                  <b>What makes us unique?</b>
                </p>
                <p>
                  <b>Curated Collections: </b>We handpick a diverse range of
                  artworks by established and emerging Indian artists, ensuring
                  you discover the perfect piece for your taste.
                </p>
                <p>
                  <b>Unveiling New Voices: </b>Be among the first to discover
                  the exciting talent of India's up-and-coming artists.
                </p>
                <p>
                  <b>The Convenience of Online Browsing: </b>Explore our
                  exhibitions from the comfort of your home, anytime, anywhere.
                </p>
                <p>
                  <b>Looking for a specific style or theme? </b>We offer a vast
                  collection, making it easy to find artwork that speaks to you.{" "}
                  <b>
                    IndiGalleria is your one-stop shop to experience the
                    vibrancy and innovation of contemporary Indian art.
                  </b>
                </p>
              </div>
            </div>

            {/* Live Exhibition Section */}
            <div className="col-md-12">
              <h2 className="sec_title">Live Exhibition</h2>
              <div className="live_exb mb-5">
                <div className="row">
                  <div className="col-sm-5">
                    <div className="imgpreview p-0">
                      <img
                        src={newdataLive === 'NA' || !newdataLive.imageURL ? "../images/exhibitionImage2.png" : "../images/exhibition/thumbnail/" + newdataLive.imageURL} //"../images/exhibitionImage2.png"
                        alt="Exhibition"
                        height={300}
                      />
                    </div>
                  </div>
                  <div className="col-sm-5">
                    <div className="imgpreview1 mt-5">
                      <h2 className="fs-6 ">{newdataLive.exhibitionTitle}</h2>
                      <span className="d-block mb-4">
                        <b>Exhibition Date:</b> {newdataLive.exhibitionDate}
                      </span>

                      <span
                        className="d-block"
                        dangerouslySetInnerHTML={{
                          __html: `<b>About Exhibition</b> ${newdataLive.description}`,
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div className="imgpreview1 mt-5">
                      <Link to={`/exhibitionLive/${newdataLive.id}`} onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}>
                        <img src="../images/JoinNow.gif" alt="Exhibition" width={200} style={{ cursor: "pointer" }} />
                      </Link>

                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="artistrow">
                      {newExbArtistLive.map((artist, index) => (
                        <div key={index} className="artistimg">
                          <img 
                              src={`../../../images/artist/thumbnail/${artist?.imageURLArtist}`} 
                              alt={`Artist ${index + 1}`} 
                              onClick={() => handleExbDetails(newdataLive.id, artist?.artistID)} 
                              style={{ cursor: "pointer" }}
                              />
                          <span 
                              className="artistname"
                              onClick={() => handleArtistLiveClick(artist?.artistID, artist?.artistName)} 
                              style={{ cursor: "pointer" }}
                          >
                              {artist?.artistName}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>



            {/* Next Exhibition Section */}
            <div className="col-md-12">
              <h2 className="sec_title">Next Online Exhibition:</h2>
              <div className="live_exb mb-5">
                <div className="row">
                  <div className="col-sm-5">
                    <div className="imgpreview p-0">
                      <img
                        src={newdataLive === 'NA' || !newdataNext.imageURL ? "../images/exhibitionImage3.jpg" : "../images/exhibition/thumbnail/" + newdataNext.imageURL} //src="../images/exhibitionImage3.jpg"
                        alt="Exhibition"
                        height={300}
                      />
                    </div>
                  </div>
                  <div className="col-sm-7 p-4">
                    <div className="imgpreview1">
                      <h2 className="fs-6">{newdataNext.exhibitionTitle}</h2>
                      <span className="d-block">
                        <b>Exhibition Date:</b> {newdataNext.exhibitionDate}
                      </span>
                      <span
                        className="d-block"
                        dangerouslySetInnerHTML={{
                          __html: `<b>About Exhibition</b> ${newdataNext.description}`,
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    <div className="artistrow">
                      {newExbArtistNext.map((artist, index) => (
                        <div key={index} className="framepic">
                          <img 
                              src={`../../../images/artist/thumbnail/${artist?.imageURLArtist}`} 
                              alt={`Artist ${index + 1}`} 
                              
                              />
                          <span className="artistname">{artist?.artistName}</span>
                          <Link className="read-more" to="javascript:void(0)"  onClick={() => handleArtistNextClick(artist?.artistID, artist?.artistName)}>About</Link>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr />

            {/* Upcoming Exhibitions Section */}
            <div className="col-md-12 pd-list">
              <h2 className="sec_title">Upcoming Online Exhibitions:</h2>
              <DataTable columns={columns} data={newdataUpcoming} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Exhibitions;
